import { GET_BASIC_INFO_MESSAGE , UPDATE_BASICINFO_SECTION , ANSWERS_SUBMIT_DATA} from './action';

const initState = {
    repeatCount:1
};
const reducer = (state = initState, action) => {
    switch (action.type) {
        case GET_BASIC_INFO_MESSAGE: 
            return {
                ...state,
                ...action.data
            };
        case UPDATE_BASICINFO_SECTION: 
            return {
                ...state,
                section: {...action.data}
            };
        case ANSWERS_SUBMIT_DATA:
            return {
                ...state,
                isSumbitAnswer: action.data
            }
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/views/BasicInfo/state/reducer.js